import React from 'react'
import StatisticsTable from './StatisticsTable'

const StatisticsForMyCompany = () => {
  return (
    <StatisticsTable />
  )
}

export default StatisticsForMyCompany